import client from 'api/client'
import { getDeviceId } from 'utils/device/deviceId'

// --- Reads ---
export const getUserDetails = () => client.get('/auth/user/details')
export const getDealerDetails = () => client.get('/auth/dealer/details')
export const getSellerFinancialDetails = () =>
  client.get('/auth/financial/seller/details')

// --- User / personal ---
export const updateUser = (id, body, config) =>
  client.put(`/auth/user/update/${id}`, body, config)
export const changePassword = (body, config) =>
  client.post('/auth/user/change-password', body, config)
export const updateEmail = (body, config) =>
  client.post('/auth/user/update-email', body, config)
export const updateSignature = (body, config) =>
  client.patch('/auth/user/signature', body, config)
export const softDeleteUser = (id) =>
  client.patch(`/auth/user/${id}/soft-delete`)
// device_id lets the API deactivate only this browser's push registration;
// sent as a query param so it needs no CORS header allowance.
export const logout = () => {
  const deviceId = getDeviceId()
  return client.get('/auth/logout', {
    params: deviceId ? { device_id: deviceId } : undefined,
  })
}

// --- Dealer ---
export const createDealer = (body, config) =>
  client.post('/auth/dealer/create', body, config)
export const updateDealer = (id, body, config) =>
  client.put(`/auth/dealer/update/${id}`, body, config)

// --- Seller financial ---
export const createSellerFinancial = (body, config) =>
  client.post('/auth/financial/seller/create', body, config)
export const updateSellerFinancial = (id, body, config) =>
  client.put(`/auth/financial/seller/update/${id}`, body, config)

// --- Payments / billing portal ---
export const getCustomerId = () => client.get('/payment/customer-id')
export const createPortalSession = (body, config) =>
  client.post('/payment/create-portal-session', body, config)

// --- Payment Contact ---
export const getPaymentContact = () => client.get('/auth/user/payment-contact')
export const updatePaymentContact = (body, config) =>
  client.put('/auth/user/payment-contact', body, config)
